jQuery(document).ready(function($) {
	var notebook = 1400;
	var tablet = 768;
	var mobile = 480;

	$('.search-faq-input').focus();
	
	var height = $('#singapore-head').height();
    $(window).scroll(function(){
        if($(this).scrollTop() > height){
            $('.page-menu-class').addClass('top-fixed');
        }else{
            $('.page-menu-class').removeClass('top-fixed');
        }
    })


	//$('.tab-content').hide();

	/*$('.step-open').each(function() {
		$(this).click(function(){
			$(this).next().slideToggle('slow');
		})
	});*/


	/*$('a#ppl').click(function(){
		$('.tab-content.rpl').fadeOut();
		$('.tab-content.ppl').slideDown('slow');
		$('.step-holder#ppl').css('margin-top', '40px');
	})

	$('a#cpl').click(function(){
		$('.tab-content.ppl').fadeOut();
		$('.tab-content.cpl').slideDown('slow');
		$('.step-holder#cpl').css('margin-top', '40px');
	})

	$('a#atpl').click(function(){
		$('.tab-content.cpl').fadeOut();
		$('.tab-content.atpl').slideDown('slow');
		$('.step-holder#atpl').css('margin-top', '40px');
	})*/

	$(".hamburger").click(function(e) {
		e.preventDefault();
		$(this).addClass("open-menu");
		$(".mobile-nav").css("right", "0%");
	});

	$(".mobile-nav .menu-item-has-children > a").click(function(e) {
		e.preventDefault();
		// $(".mobile-nav").css("width", "20%");
	});

	$(".close-mobile-nav").click(function(e) {
		e.preventDefault();
		$(".hamburger").removeClass("open-menu");
		$(".mobile-nav").css("right", "-100%");
		$(".mobile-nav").css("width", "100%");
	});
	

	//shop submenu - Local 
	/*


	$(".site-header #menu-item-7552").on("mouseover", function() {
		$(".shop-mega-shopmenu-beginner").addClass("add-flex");
		$(this).addClass("add-bg");
	});

	$(".site-header #shop-page-menu > li:not(#menu-item-7552)").on("mouseover", function() {
		$(".shop-mega-shopmenu-beginner").removeClass("add-flex");
		$("#menu-item-7552").removeClass("add-bg");
		
	});

	$(".site-header #menu-item-7540").on("mouseover", function() {
		$(".shop-mega-shopmenu-ppl").addClass("add-flex");
		$(this).addClass("add-bg");
	});

	$(".site-header #shop-page-menu > li:not(#menu-item-7540)").on("mouseover", function() {
		$(".shop-mega-shopmenu-ppl").removeClass("add-flex");
		$("#menu-item-7540").removeClass("add-bg");
	});
	

	$(".site-header #menu-item-7598").on("mouseover", function() {
		$(".shop-mega-shopmenu-re").addClass("add-flex");
		$(this).addClass("add-bg");
	});

	$(".site-header #shop-page-menu > li:not(#menu-item-7598)").on("mouseover", function() {
		$(".shop-mega-shopmenu-re").removeClass("add-flex");
		$(this).addClass("add-bg");
		$("#menu-item-7598").removeClass("add-bg");
	});

	
	$(".site-header #menu-item-7599").on("mouseover", function() {
		$(".shop-mega-shopmenu-ate").addClass("add-flex");
		$(this).addClass("add-bg");
	});

	$(".site-header #shop-page-menu > li:not(#menu-item-7599)").on("mouseover", function() {
		$(".shop-mega-shopmenu-ate").removeClass("add-flex");
		$("#menu-item-7599").removeClass("add-bg");
	});
	

	$(".site-header #menu-item-7601").on("mouseover", function() {
		$(".shop-mega-shopmenu-aip").addClass("add-flex");
		$(this).addClass("add-bg");
	});

	$(".site-header #shop-page-menu > li:not(#menu-item-7601)").on("mouseover", function() {
		$(".shop-mega-shopmenu-aip").removeClass("add-flex");
		$("#menu-item-7601").removeClass("add-bg");
	});
	

	$(".site-header #menu-item-8770").on("mouseover", function() {
		$(".shop-mega-shopmenu-tc").addClass("add-flex");
		$(this).addClass("add-bg");
	});

	$(".site-header #shop-page-menu > li:not(#menu-item-8770)").on("mouseover", function() {
		$(".shop-mega-shopmenu-tc").removeClass("add-flex");
		$("#menu-item-8770").removeClass("add-bg");
	});

	

	$(".shop-mega-shopmenu-beginner").on("mouseleave", function() {
		$(".shop-mega-shopmenu-beginner").removeClass("add-flex");
		$("#menu-item-7552").removeClass("add-bg");
	});

	$(".shop-mega-shopmenu-ppl").on("mouseleave", function() {
		$(".shop-mega-shopmenu-ppl").removeClass("add-flex");
		$("#menu-item-7540").removeClass("add-bg");
	});

	$(".shop-mega-shopmenu-re").on("mouseleave", function() {
		$(".shop-mega-shopmenu-re").removeClass("add-flex");
		$("#menu-item-7598").removeClass("add-bg");
	});

	$(".shop-mega-shopmenu-ate").on("mouseleave", function() {
		$(".shop-mega-shopmenu-ate").removeClass("add-flex");
		$("#menu-item-7599").removeClass("add-bg");
	});

	$(".shop-mega-shopmenu-aip").on("mouseleave", function() {
		$(".shop-mega-shopmenu-aip").removeClass("add-flex");
		$("#menu-item-7601").removeClass("add-bg");
	});

	$(".shop-mega-shopmenu-tc").on("mouseleave", function() {
		$(".shop-mega-shopmenu-tc").removeClass("add-flex");
		$("#menu-item-8770").removeClass("add-bg");
	}); */


	// Above is for Local 

	
	/*$("#shop-mega-shopmenu").on("mouseleave", function() {
		$("#shop-mega-shopmenu").removeClass("add-flex");
	});*/

// Below is for Live 

	$(".site-header #menu-item-93494").on("mouseover", function() {
		$(".shop-mega-shopmenu-beginner").addClass("add-flex");
		$(this).addClass("add-bg");
	});

	$(".site-header #shop-page-menu > li:not(#menu-item-93494)").on("mouseover", function() {
		$(".shop-mega-shopmenu-beginner").removeClass("add-flex");
		$("#menu-item-93494").removeClass("add-bg");
	});
	
	$(".site-header #menu-item-89056").on("mouseover", function() {
		$(".shop-mega-shopmenu-ppl").addClass("add-flex");
		$(this).addClass("add-bg");
	});

	$(".site-header #shop-page-menu > li:not(#menu-item-89056)").on("mouseover", function() {
		$(".shop-mega-shopmenu-ppl").removeClass("add-flex");
		$("#menu-item-89056").removeClass("add-bg");
	});
	

	$(".site-header #menu-item-89059").on("mouseover", function() {
		$(".shop-mega-shopmenu-re").addClass("add-flex");
		$(this).addClass("add-bg");
	});

	$(".site-header #shop-page-menu > li:not(#menu-item-89059)").on("mouseover", function() {
		$(".shop-mega-shopmenu-re").removeClass("add-flex");
		$(this).addClass("add-bg");
		$("#menu-item-89059").removeClass("add-bg");
	});

	
	$(".site-header #menu-item-93831").on("mouseover", function() {
		$(".shop-mega-shopmenu-ate").addClass("add-flex");
		$(this).addClass("add-bg");
	});

	$(".site-header #shop-page-menu > li:not(#menu-item-93831)").on("mouseover", function() {
		$(".shop-mega-shopmenu-ate").removeClass("add-flex");
		$("#menu-item-93831").removeClass("add-bg");
	});


	$(".site-header #menu-item-89058").on("mouseover", function() {
		$(".shop-mega-shopmenu-aip").addClass("add-flex");
		$(this).addClass("add-bg");
	});

	$(".site-header #shop-page-menu > li:not(#menu-item-89058)").on("mouseover", function() {
		$(".shop-mega-shopmenu-aip").removeClass("add-flex");
		$("#menu-item-89058").removeClass("add-bg");
	});
	

	$(".site-header #menu-item-89060").on("mouseover", function() {
		$(".shop-mega-shopmenu-tc").addClass("add-flex");
		$(this).addClass("add-bg");
	});

	$(".site-header #shop-page-menu > li:not(#menu-item-89060)").on("mouseover", function() {
		$(".shop-mega-shopmenu-tc").removeClass("add-flex");
		$("#menu-item-89060").removeClass("add-bg");
	});
	


	$(".shop-mega-shopmenu-beginner").on("mouseleave", function() {
		$(".shop-mega-shopmenu-beginner").removeClass("add-flex");
		$("#menu-item-93494").removeClass("add-bg");
	});

	$(".shop-mega-shopmenu-ppl").on("mouseleave", function() {
		$(".shop-mega-shopmenu-ppl").removeClass("add-flex");
		$("#menu-item-89056").removeClass("add-bg");
	});

	$(".shop-mega-shopmenu-re").on("mouseleave", function() {
		$(".shop-mega-shopmenu-re").removeClass("add-flex");
		$("#menu-item-89059").removeClass("add-bg");
	});

	$(".shop-mega-shopmenu-ate").on("mouseleave", function() {
		$(".shop-mega-shopmenu-ate").removeClass("add-flex");
		$("#menu-item-93831").removeClass("add-bg");
	});

	$(".shop-mega-shopmenu-aip").on("mouseleave", function() {
		$(".shop-mega-shopmenu-aip").removeClass("add-flex");
		$("#menu-item-89058").removeClass("add-bg");
	});

	$(".shop-mega-shopmenu-tc").on("mouseleave", function() {
		$(".shop-mega-shopmenu-tc").removeClass("add-flex");
		$("#menu-item-89060").removeClass("add-bg");
	});

	// END LIVE


	//Shop submenu item end 

	$('.close-button').click(function(){
		$("#mega-menu-courses").removeClass("add-flex");
	})

	$(".site-header #menu-item-11").on("mouseover", function() {
		$("#mega-menu-courses").addClass("add-flex");
	});

	$(".site-header #menu-item-13").on("mouseover", function() {
		$("#mega-menu-fleet").addClass("add-flex");
	});

	$(".site-header #primary-menu > li:not(#menu-item-11)").on("mouseover", function() {
		$("#mega-menu-courses").removeClass("add-flex");
	});

	$(".site-header #primary-menu > li:not(#menu-item-13)").on("mouseover", function() {
		$("#mega-menu-fleet").removeClass("add-flex");
	});

	$("#mega-menu-courses").on("mouseleave", function() {
		$("#mega-menu-courses").removeClass("add-flex");
	});

	$("#mega-menu-fleet").on("mouseleave", function() {
		$("#mega-menu-fleet").removeClass("add-flex");
	});

	var html = '<li class="menu-line"></li>';
	$("#mobile-menu").append(html);

	$("#menu-item-27").addClass("focus");

	$("#menu-item-73 .sub-menu > li > a:not(.back-container)").click(function() {
		$("#menu-item-73 > .sub-menu").css("left", "-110%");
		$("#menu-item-73 > .sub-menu .sub-menu").hide();
		$("#menu-item-73 > .sub-menu > li > a").next().hide();
		$(this).next().show();
	});

	$('#mobile-shop-menu > li > .sub-menu').each(function(){
		var html = '<li class="back-container"><a class="back" href="#">Back</a></li>';
		$(this).prepend(html);

		$(".back").bind("click", function(e) {
			e.preventDefault();
			$(this).parent().parent().css('left', '110%');
			$("#mobile-shop-menu").css("left", "0%");
			setTimeout(() => {
				$(this).parent().parent().removeAttr('style');
				$(this).parent().parent().removeClass('slide-left');
				$("#mobile-shop-menu").removeAttr('style');
			}, 100);
		});
	});

	$('#mobile-shop-menu > li').each(function(){
		$(this).click(function(){
			$(this).find('.sub-menu').addClass('slide-left');
			$(this).next().show();
		})
	})

	$(".course-nav-btn").click(function(e) {
		e.preventDefault();
		if($(this).hasClass("on")) {
			$(this).removeClass("on");
			$(".course-nav").css("max-height", "0px");
		} else {
			$(this).addClass("on");
			$(".course-nav").css("max-height", "500px");
		}
	});

	$(".course-nav a").click(function(e) {
		$(".area").html($(this).text());
		$(".course-nav-btn").removeClass("on");
		$(".course-nav").css("max-height", "0px");
	});

	// code for flight instructor rating
	$('.endorsement').click(function(){
		var training = $('.training-text');
		var requirements = $('.requirements-text');
		var course_available = $('.course-text');
		var date = $('.date-text');

		checkEmpty(training);
		checkEmpty(requirements);
		checkEmpty(course_available);
		checkEmpty(date);

		training.html($(this).attr('data-training'));
		requirements.html($(this).attr('data-requirements'));
		course_available.html($(this).attr('data-available'));
		date.html($(this).attr('data-date'));

		// function getPDF() {
		// 	var pdf = 
		// }

		// set the href for
		
		var link = $(this).attr('data-pdf');
		var enrol = $(this).attr('data-enrol');

		var button = $('.course-fir-button');
		var enrolButton = $('.enrol-button');

		enrolButton.attr('href', enrol);
		button.attr('href', link);


	})

	
	// create code for diploma, clear out all the fields and populate with attributes
	$('.diploma-degree').on('click', function(e){
		e.preventDefault();

		// get all the attribute containers
		var campus = $('.campus-text');
		var duration = $('.duration-text');
		var credit_points = $('.credit-points-text');
		var cost = $('.cost-text');
		var cricos_code = $('.cricos-text');
		var entry_requirements = $('.entry-text');
		var commencement = $('.commencing-text');
		var degree_code = $('.degree-text');
		var included = $('.whats-included .items');

		checkEmpty(campus);
		checkEmpty(duration);
		checkEmpty(credit_points);
		checkEmpty(cost);
		checkEmpty(cricos_code);
		checkEmpty(entry_requirements);
		checkEmpty(commencement);
		checkEmpty(degree_code);

		campus.html($(this).attr('data-campus'));
		duration.html($(this).attr('data-duration'));
		credit_points.html($(this).attr('data-credit'));
		cost.html($(this).attr('data-cost'));
		cricos_code.html($(this).attr('data-code'));
		entry_requirements.html($(this).attr('data-requirements'));
		commencement.html($(this).attr('data-commencement'));
		degree_code.html($(this).attr('data-degree-code'));
		included.html($(this).attr('data-included'));

	})

	function checkEmpty(el) {
		if(el.length !== 0) {
			el.html('');
		}
	}

	function moveLine() {
		$(".menu-line").css("width", $(".focus > a").width());
		$(".menu-line").css("left", $(".focus > a").offset().left - $("#mobile-menu").offset().left);
	}

	$("#mobile-menu > li > a").click(function() {
		$("#mobile-menu > li").removeClass("focus");
		$(this).parent().addClass("focus");
		moveLine();
	});

	$("#menu-item-88422").click(function() {
		$("#mobile-menu > li").removeClass("focus");
		$("#menu-item-73").addClass("focus");
		moveLine();
	});

	$("#menu-item-88423").click(function() {
		$("#mobile-menu > li").removeClass("focus");
		$("#menu-item-74").addClass("focus");
		moveLine();
	});

	$("#menu-item-88427").click(function() {
		$("#mobile-menu > li").removeClass("focus");
		$("#menu-item-88424").addClass("focus");
		moveLine();
	});

	// create code for bachelors selection, clear out all the fields and populate with attributes
	$('.bachelor-degree').on('click', function(e){
		e.preventDefault();

		// get all the attribute containers
		var campus = $('.campus-text');
		var duration = $('.duration-text');
		var credit_points = $('.credit-points-text');
		var cost = $('.cost-text');
		var cricos_code = $('.cricos-text');
		var entry_requirements = $('.entry-text');
		var commencement = $('.commencing-text');
		var degree_code = $('.degree-text');
		var included = $('.whats-included .items');

		checkEmpty(campus);
		checkEmpty(duration);
		checkEmpty(credit_points);
		checkEmpty(cost);
		checkEmpty(cricos_code);
		checkEmpty(entry_requirements);
		checkEmpty(commencement);
		checkEmpty(degree_code);

		campus.html($(this).attr('data-campus'));
		duration.html($(this).attr('data-duration'));
		credit_points.html($(this).attr('data-credit'));
		cost.html($(this).attr('data-cost'));
		cricos_code.html($(this).attr('data-code'));
		entry_requirements.html($(this).attr('data-requirements'));
		commencement.html($(this).attr('data-commencement'));
		degree_code.html($(this).attr('data-degree-code'));
		included.html($(this).attr('data-included'));
	})

	// function for handling package clicks
	$(".package").click(function(e) {
		e.preventDefault();
		var individualPackage = $(this).text();

		$(".package").removeClass("selected");
		$(this).addClass("selected");
		
		var packageName = $('.package-details .name');
		var packageHours = $('.flying-hours .hours');
		var payments = $('.payf');
		var simulation = $('.simulation-hours');
		var theory = $('.theory');
		var firstLine = $('.for-mobile > .final-price + .line');
		//var line = $('.line');
		var splitit = $('.splitit-section');
		var included = $('.whats-included');
		var includedHeading = $('.whats-included h4');
		var traningConduct = $('.training');
		var requirment = $('.min-requirment');
		var courseAvailability = $('.course-availability');
		var nextCourse = $('.next-course');
		
		var singaporecoursetitle = $('.singaporecoursetitle');
		var singaporecoursetext = $('.singaporecoursetext');
		
		var singaporeflyinghours = $('.singaporeflyinghours');
		var singaporeaircraft = $('.singaporeaircraft');
		var singaporelocation = $('.singaporelocation');
		var singaporepackageprice = $('.singaporepackageprice');
		var singaporewhatsincluded = $('.singaporewhatsincluded');

		if(singaporecoursetext.html() !== '') {
			singaporecoursetext.html('');
		}
		if(singaporecoursetitle.html() !== '') {
			singaporecoursetitle.html('');
		}

		if(singaporeflyinghours.html() !== '') {
			singaporeflyinghours.html('');
		}
		if(singaporeaircraft.html() !== '') {
			singaporeaircraft.html('');
		}
		if(singaporelocation.html() !== '') {
			singaporelocation.html('');
		}
		if(singaporepackageprice.html() !== '') {
			singaporepackageprice.html('');
		}
		if(singaporewhatsincluded.html() !== '') {
			singaporewhatsincluded.html('');
		}
		
		if(packageName.html() !== '') {
			packageName.html('');
		}

		if(traningConduct.html() !== '') {
			traningConduct.html('');
		}

		if(requirment.html() !== '') {
			requirment.html('');
		}

		if(courseAvailability.html() !== '') {
			courseAvailability.html('');
		}

		if(nextCourse.html() !== '') {
			nextCourse.html('');
		}

		if($(this).attr('data-package') == 'PAYG') {
			payments.html(' ');
			simulation.html(' ');
			theory.html(' ');
			packageHours.html(' ');
			includedHeading.html('PAYG Items');
			firstLine.hide();
			splitit.hide();
			included.html();
		} else {
			includedHeading.html('Whats included?')
			splitit.show();
			included.show();
		}

		singaporecoursetitle.html($(this).attr('data-singaporecoursetitle'));
		singaporecoursetext.html($(this).attr('data-singaporecoursetext'));

		
		singaporeflyinghours.html($(this).attr('data-singaporeflyinghours'));
		singaporeaircraft.html($(this).attr('data-singaporeaircraft'));
		singaporelocation.html($(this).attr('data-singaporelocation'));
		singaporepackageprice.html($(this).attr('data-singaporepackageprice'));
		singaporewhatsincluded.html($(this).attr('data-singaporewhatsincluded'));

		packageName.html($(this).attr('data-package'));
		traningConduct.html($(this).attr('data-traning'));
		requirment.html($(this).attr('data-requirment'));
		courseAvailability.html($(this).attr('data-availability'));
		nextCourse.html($(this).attr('data-next'));

		// function getPDF() {
		// 	var pdf = 
		// }

		// set the href for

		var singaporelink = $(this).attr('data-singaporecourseguideurl');
		var singaporebutton = $('.course-singapore-button');

		singaporebutton.attr('href', singaporelink);


		
		var singaporeenrol = $(this).attr('data-seecoursepageurl');
		var singaporeenrolButton = $('.see-course-page-button');

		singaporeenrolButton.attr('href', singaporeenrol);
		

		// var index = 0;
		$(".aircraft").each(function() {
			$(this).hide();
			if($(this).attr("data-package") == individualPackage) {
				$(this).show();
				// if($index == 0) {
				// 	$(this).addClass("selected");
				// 	$index++;
				// } else {
				// 	$(this).removeClass("selected");
				// }
			}
		});
	});

	if($("body").hasClass("page-template-page_singapore")) {
		$(".package")[0].click();
	}
	if($("body").hasClass("home")) {
		$(".package")[0].click();
	}

	// function for handling aircraft clicks
	$(".aircraft").click(function(e) {
		e.preventDefault();
		$(".aircraft").removeClass("selected");
		$(this).addClass("selected");

		var packagePrice = $('.package-price');
		var simulation = $('.simulation-hours');
		var theory = $('.theory');
		var paymentOptions = $('.payf');
		var packageHours = $('.flying-hours .hours');
		var splitit = $('.splitit-option');
		var included = $('.whats-included .items');

		var traningConduct = $('.training');
		var requirment = $('.min-requirment');
		var courseAvailability = $('.course-availability');
		var nextCourse = $('.next-course');
		
		if(packageHours.html() !== '') {
			packageHours.html('');
		}

		if(packagePrice.html() !== '') {
			packagePrice.html('');
		}

		if(paymentOptions.html() !== '') {
			paymentOptions.html('');
		}

		if(simulation.html() !== '') {
			simulation.html('');
		}

		if(theory.html() !== '') {
			theory.html('');
		}

		if(included.html() !== '') {
			included.html('');
		}

		if(traningConduct.html() !== '') {
			traningConduct.html('');
		}

		if(requirment.html() !== '') {
			requirment.html('');
		}

		if(courseAvailability.html() !== '') {
			courseAvailability.html('');
		}

		if(nextCourse.html() !== '') {
			nextCourse.html('');
		}

		if($(this).attr('data-package') == 'PAYG') {
			packagePrice.html('AUD: PAY AS YOU GO');
			
		} else {
			packagePrice.html($(this).attr('data-price'));
		}
		
		simulation.html($(this).attr('data-simulation'));
		theory.html($(this).attr('data-theory'));
		splitit.html($(this).attr('data-splitit'));
		included.html($(this).attr('data-included'));

		traningConduct.html($(this).attr('data-traning'));
		requirment.html($(this).attr('data-requirment'));
		courseAvailability.html($(this).attr('data-availability'));
		nextCourse.html($(this).attr('data-next'));

		if($(this).attr('data-value') == '') {
			packageHours.html($(this).attr('data-payf'));
		} else {
			packageHours.html($(this).attr('data-value'));
		}  

	});

	function moveLine() {
		$(".menu-line").css("width", $(".focus > a").width());
		$(".menu-line").css("left", $(".focus > a").offset().left - $("#mobile-menu").offset().left);
	}

	$("#mobile-menu > li > a").click(function() {
		$("#mobile-menu > li").removeClass("focus");
		$(this).parent().addClass("focus");
		moveLine();
	});

	$("#menu-item-88422").click(function() {
		$("#mobile-menu > li").removeClass("focus");
		$("#menu-item-73").addClass("focus");
		moveLine();
	});

	$("#menu-item-88423").click(function() {
		$("#mobile-menu > li").removeClass("focus");
		$("#menu-item-74").addClass("focus");
		moveLine();
	});

	$("#menu-item-88427").click(function() {
		$("#mobile-menu > li").removeClass("focus");
		$("#menu-item-88424").addClass("focus");
		moveLine();
	});

	$("#menu-item-73 > .sub-menu .sub-menu").each(function() {
		var html = '<li class="back-container"><a class="back" href="#">Back</a></li>';
		$(this).prepend(html);

		$(".back").bind("click", function(e) {
			e.preventDefault();
			$("#menu-item-73 > .sub-menu").css("left", "0%");
		});
	});

	function getHeight() {
		var firstHeight = '';
		if($(window).width() > 800) {
			firstHeight = $('.get-height').height() - 81 + 41;
		} else {
			firstHeight = $('.get-height').height();
		}
		var secondHeight = $('.program-holder .image-holder img');

		secondHeight.css('height', firstHeight);
	}

	$(window).resize(function() {
		// resizeCourseBannerImage();
		getBodyContentHeight();
		getHeight();
		if(!$("body").hasClass("woocommerce-page")) {
			moveLine();
		}
	}).resize();

	$(window).load(function() {
		getBodyContentHeight();
		loadCoursePackageOptions();
		$(".menu-line").css("width", $(".focus > a").width());
	});

	getMenuItemsDesktop("Beginner Programs");
	$(".level-2 .menu-item-29 a").addClass("selected");

	$(".level-2 a").click(function(e) {
		e.preventDefault();
		$(".level-2 a").removeClass("selected");
		$(this).addClass("selected");
		getMenuItemsDesktop($(this).text());
	});

	
	function loadCoursePackageOptions() {
		var coursePackage = $(".package.selected").text();
		$(".aircraft").each(function() {
			if($(this).attr("data-package") !== coursePackage) {
				$(this).addClass("hide");
			} else {
				$(this).removeClass("hide");
			}
		});
	}


	
	function getBodyContentHeight() {
		$(".main-content").css("height", $(".main-content").outerHeight());
	}

	// function resizeCourseBannerImage() {
	// 	$(".course-image").css("height", "calc(100vh - " + $(".site-branding").height() + "px - " + $("#mini-menu-courses").height() + "px)");
	// }



	function getMenuItemsDesktop(item) {
		$.ajax({
			type: "POST",
			url: local.webservice,
			data: {
				action: "get_menu_items",
				navitem: item
			},
			success: function(d) {
				$(".level-3 .menu-header-menu-container").remove();
				$(".level-3 .dot").remove();

				$(".level-3 .circle-container").append(d);

				var len = $(".level-3 li").length;
				var width = $(window).width();

				if(width < 1101) {
					var r = 150;
					var c = 250;
					var d = 210;
				} else if(width > 901 && width < 1280) {
					var r = 180;
					var c = 250;
					var d = 250;
				} else if (width >= 1023 && width <= 1024) {
					var r = 180;
					var c = 250;
					var d = 250;
				} else {
					var r = 224;
					var c = 330;
					var d = 280;
				}

			  	var angle = 0;
			  	var step = 2*Math.PI/len;

				for(var i = 1; i <= len; i++) {
					if(width < 1101) {
						var x = r * Math.sin(angle) + 133;
		  				var y = r * Math.cos(angle) + 133;
		  				var a = c * Math.sin(angle) + 133;
		  				var b = d * Math.cos(angle) + 133;
					} else if(width > 901 && width < 1280) {
						var x = r * Math.sin(angle) + 163;
		  				var y = r * Math.cos(angle) + 163;
		  				var a = c * Math.sin(angle) + 205;
		  				var b = d * Math.cos(angle) + 158;
					} else {
						var x = r * Math.sin(angle) + 207;
		  				var y = r * Math.cos(angle) + 207;
		  				var a = c * Math.sin(angle) + 207;
		  				var b = d * Math.cos(angle) + 207;
		  			}

					if (width >= 1023 && width <= 1024) {
						var x = r * Math.sin(angle) + 135;
		  				var y = r * Math.cos(angle) + 135;
		  				var a = c * Math.sin(angle) + 170;
		  				var b = d * Math.cos(angle) + 120;
					} 

					// a is left
					// b is top
					
					// this one is for the blue dot
					//  y is top
					//  x is left

	  				html = '<a href="' + $(".level-3 li:nth-child(" + i + ") a").attr("href") + '" class="dot" style="display: block; width: 32px; height: 32px; background-color: #00acf3; border-radius: 50%; position: absolute; top: ' + y + 'px; left: ' + x + 'px;"></a>';
	  				$(".circle-container").append(html);
	  				$(".level-3 li:nth-child(" + i + ")").css("left", a);
	  				$(".level-3 li:nth-child(" + i + ")").css("top", b);

					// // ipad screen
					if(width >= 1023 && width <= 1024) {
						// stuff here
						if(b > 300) {
							$(".level-3 li:nth-child(" + i + ")").addClass('adjust-right');
						}
					}

					//   screens in the middle from 1101px to 1280px

					if(width >= 901 && width <= 1280) {

						if(b > 400) {
							$(".level-3 li:nth-child(" + i + ")").css("top", b - 20);
							$(".level-3 li:nth-child(" + i + ")").addClass('adjust-right');
						}

						if(b < 0) {
							$(".level-3 li:nth-child(" + i + ")").css("top", b + 25);
						} else {
							$(".level-3 li:nth-child(" + i + ")").css("top", b - 3);
							$(".level-3 li:nth-child(" + i + ")").css("left", a - 30);
						}


						if($(".level-3 li:nth-child(" + i + ") a").text().length > 40) {
							$(".level-3 li:nth-child(" + i + ") a").css("width", "140px");
							// $(".level-3 li:nth-child(" + i + ")").css("transform", "translate(-50%, -16%)");
						} else {
							$(".level-3 li:nth-child(" + i + ") a").css("width", "115px");
						}
					}
					
					//  large screens

					  if(width > 1280 ) {
						if(b < 0) {
							$(".level-3 li:nth-child(" + i + ")").addClass('adjust-to-right');
							$(".level-3 li:nth-child(" + i + ")").css("top", b - 10);
						}
	
						if(b > 450) {
							$(".level-3 li:nth-child(" + i + ")").addClass('adjust-to-left');
							$(".level-3 li:nth-child(" + i + ")").css("left", a + 60);
						}

						if($(".level-3 li:nth-child(" + i + ") a").text().length > 40) {
							$(".level-3 li:nth-child(" + i + ") a").css("width", "158px");
							// $(".level-3 li:nth-child(" + i + ")").css("transform", "translate(-50%, -16%)");
						}
					  }


	  				angle = angle + step;
	  				// console.log(step);
				}
			}
		});
	}

	var marker = document.querySelector('.shift');
	var anchors = document.querySelectorAll('.anchor-link');

	function indicate(e) {
		marker.style.left = e.offsetLeft+'px';
		marker.style.width = e.offsetWidth+'px';
	}

	// anchors.forEach(link => {
	// 	link.addEventListener('click', (e) => {
	// 		indicate(e.target);
	// 	})
	// })

	// add active class on scroll
	// var addClassOnScroll = function () {
	// 	var windowTop = $(window).scrollTop();
	// 	$('div[id]').each(function (index, elem) {
	// 		var offsetTop = $(elem).offset().top;
	// 		var outerHeight = $(this).outerHeight(true);
	
	// 		if( windowTop > (offsetTop - 50) && windowTop < ( offsetTop + outerHeight)) {
	// 			var elemId = $(elem).attr('id');

	// 			$(".left-items a.anchor-link").removeClass('active');
	// 			$(".left-items a.anchor-link[href='#" + elemId + "']").addClass('active');

	// 			$('.anchor-link').each(function(index, el) {
	// 				if($(this).hasClass('active')) {
	// 					indicate(el);
	// 				}
	// 			})
	// 		}
	// 	});
	// };

	function stickSearchBar() {
		if($(window).width() <= 1023) {
			if($(window).scrollTop() >= 311) {
				$('.mobile-target').addClass('fixed');
			} else {
				$('.mobile-target').removeClass('fixed');
			}

			if ((window.innerHeight + window.pageYOffset) >= document.body.scrollHeight - 1800) {
				$('.mobile-target').fadeOut();
			} else {
				$('.mobile-target').fadeIn();
			}
		}
	}


	$(function () {
		$(window).on('scroll', function (e) {

			stickSearchBar();

		});
	});

	// this is to hide the navbar when scrolled to the end of the page
	function hideStickyBar() {
		var courseNavBar = $('.course-navigation');

		var observer = new IntersectionObserver(function(entries) {
			if(entries[0].isIntersecting === true) {
				courseNavBar.fadeOut();
			} else {
				courseNavBar.fadeIn();
			}
		}, { threshold: 0.5 });
		
		observer.observe(document.querySelector(".site-footer"));
	}

	if($(window).width() > 1023) {
		hideStickyBar();
	}

	if($('body').hasClass('blog') || 
	$('body').hasClass('page-template-page_loans') ||
	$('body').hasClass('page-template-page_faq') || 
	$('body').hasClass('page-template-page_courses') || 
	$('body').hasClass('page-template-page_fleet') || 
	$('body').hasClass('page-template-page_contact') ||
	$('body').hasClass('page-template-page_about') ||
	$('body').hasClass('page-template-page_online_training') ||
	$('body').hasClass('woocommerce-shop') ||
	$('body').hasClass('page-template-page_fir')) {
		$(function() {
			$('a[href*=#]:not([href=#])').click(function() {
			  if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
				var target = $(this.hash);
				target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
				if (target.length) {
				  $('html,body').animate({
					scrollTop: target.offset().top
				  }, 1000);
				  return false;
				}
			  }
			});
		});
	}
	/*------- jQuery Plugin for Road to Become a pilot--------*/

	(function($){
		$.fn.modalP = function(obj){
		var openModal;
		var obj = obj || {};
		var speed = obj.speed || 500;
		this.each( function(){
	
				$('.p-modal').css('display','none');
				$('.p-body').css('display','none');
				$('.p-close').css({ 
				"position":"absolute",
				"top":"15px",
				"right":"45px",
				"display":"none",
				"cursor":"pointer"

			});
	
					$(this).click(function(){
						openModal  = $(this);
						var pos = $(this).offset();
						var x = pos.left;
						var y = pos.top;
						var w = $(this).width();
						var h = $(this).height();
				
						var modalText = $(this).attr('p-open');
						var modal = $('.p-modal[p-modal="'+modalText+'"]');
						var body = modal.children('.p-body')
						var close = modal.children('.p-close');
	
						modal.css({
							"width":w+'px',
							"height":h+'px',
							"display":"block",
							"position":"fixed",
							"top":y+'px',
							"left":x+'px',
							"z-index":'9999999',
							"transition":"none",
							"overflow":"scroll",
							"background":"#ffffff",
							
						});
				
						modal.animate({
				
							width:"150%",
							height:"150vh",
							top:"-60px",
							left:"-110px"
				
						},speed,function(){
			
							modal.animate({
				
							width:"100%",
							height:"100vh",
							top:"0",
							left:"0",
				
							},speed/3,function(){
				
							body.fadeIn('slow');
							close.fadeIn('slow');
				
						});
			
					});
	
					close.click(function(){
						pos = openModal.offset();
						close.fadeOut(100);

						body.fadeOut(100,function(){
							modal.animate({
				
								width:"150%",
								height:"150vh",
								top:"-60px",
								left:"-110px",
				
							},0,function(){
				
								modal.animate({
				
									width:w+"px",
									height:h+"px",
									top:pos.top+"px",
									left:pos.left+"px",
					
									},speed,function(){
					
									modal.hide(0);
								});
							});
						});
					});
				});
			});
		}
	})(jQuery)
	/****************************/
	
	$(".p-open").modalP();

	/*------- End of jQuery Plugin for Road to Become a pilot--------*/

	/*------- jQuery Plugin --------*/
	(function($){
		$.fn.modalF = function(obj){
		var openModal;
		var obj = obj || {};
		var speed = obj.speed || 500;
		this.each( function(){
	
				$('.m-modal').css('display','none');
				$('.m-body').css('display','none');
				$('.m-close').css({ 
				"position":"fixed",
				"top":"15px",
				"right":"15px",
				"display":"none",
				"cursor":"pointer"

			});
	
					$(this).click(function(){
						openModal  = $(this);
						var pos = $(this).offset();
						var x = pos.left;
						var y = pos.top;
						var w = $(this).width();
						var h = $(this).height();
				
						var modalText = $(this).attr('m-open');
						var modal = $('.m-modal[m-modal="'+modalText+'"]');
						var body = modal.children('.m-body')
						var close = modal.children('.m-close');
	
						modal.css({
							"width":w+'px',
							"height":h+'px',
							"display":"block",
							"position":"fixed",
							"top":y+'px',
							"left":x+'px',
							"z-index":'9999999',
							"transition":"none"
						});
				
						modal.animate({
				
							width:"150%",
							height:"150vh",
							top:"-60px",
							left:"-110px"
				
						},speed,function(){
			
							modal.animate({
				
							width:"100%",
							height:"100vh",
							top:"0",
							left:"0",
				
							},speed/3,function(){
				
							body.fadeIn('slow');
							close.fadeIn('slow');
				
						});
			
					});
	
					close.click(function(){
						pos = openModal.offset();
						close.fadeOut(100);

					
						

						body.fadeOut(100,function(){

							
							modal.animate({
				
								width:"150%",
								height:"150vh",
								top:"-60px",
								left:"-110px",
				
							},0,function(){
				
								modal.animate({
				
									width:w+"px",
									height:h+"px",
									top:pos.top+"px",
									left:pos.left+"px",
					
									},speed,function(){
					
									modal.hide(0);
									
								});
							});
						});
					});
				});
			});
		}
	})(jQuery)
	/****************************/
	
	$(".m-open").modalF();
	
	
	/*-----------------------------*/
	
	
});

function init() {
	const accordion_items = document.querySelectorAll('.accordion_title');
	for (var i = 0; i < accordion_items.length; i++) {
		//accordion_items[0].click();
		accordion_items[i].addEventListener('click', function () {
			this.nextElementSibling.classList.toggle('show')
			this.classList.toggle('active')
			//   console.log(document.querySelector('.additional-row').innerHTML);

			if (this.classList.contains('active')) {
				this.nextElementSibling.style.maxHeight = this.nextElementSibling.scrollHeight * 4 + 'px'
			} else {
				this.nextElementSibling.style.maxHeight = 0
			}
		})
	}

	if(jQuery(window).width() > 800 && jQuery('body').hasClass('page-template-page_about')) {
		accordion_items[0].click();
	}
}

init();


// WEBPACK FOOTER //
// ./main.js